import Typography from "@mui/material/Typography";
import { type SetterOrUpdater, useRecoilState, useRecoilValue } from "recoil";
import CustomSelect from "../components/CustomSelect";
import {
	getPeriodOptions,
	getPeriodOptionsWithHourDisabled,
} from "../constants";
import { isAdminState, localeState, periodState } from "../store";
import Grid2 from "@mui/material/Grid2";
import type { SelectOptions } from "../types";

export default function Period() {
	const [period, setPeriod] = useRecoilState(periodState);
	const isAdmin = useRecoilValue(isAdminState);
	const resolvedLocale = useRecoilValue(localeState);

	return (
		<>
			<Grid2 container>
				<Grid2 size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
					<Typography>{resolvedLocale.everyText}</Typography>
					<CustomSelect
						single
						disableClearable
						options={
							isAdmin
								? getPeriodOptions(resolvedLocale.periodOptions)
								: getPeriodOptionsWithHourDisabled(resolvedLocale.periodOptions)
						}
						label={resolvedLocale.periodLabel}
						value={period}
						setValue={
							setPeriod as SetterOrUpdater<SelectOptions | SelectOptions[]>
						}
						multiple={false}
					/>
				</Grid2>
			</Grid2>
		</>
	);
}
